import { html, LitElement, css, unsafeCSS } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';

import '../components/comments';

import style from './news.scss';
import { getNameFromURL, setTitle, trackPage } from '../shared/utils';
import { DATA_CLASSES } from '../data/sources';

export class NewsPage extends LitElement {

    static get properties() {
        return {            
            news: Object
        }
    }

    constructor() {
        super();    
        this.discord = false;    
        this.news = {
            title: 'Loading...',
            content: ''
        };
    }

    static styles = css`
        ${unsafeCSS(style)}        
    `;

    connectedCallback() {
        super.connectedCallback();
        trackPage();     
        if(window.location.href.indexOf('discordnews') !== -1)
        this.discord = true;        
        setTitle(this.discord?'Discord Updates':'News');
        this.fetchData();
    }

    markdownToHTML(str){        
              
        return str;
    }

    async fetchData() {                                
        let news = await fetch(`./api/news`);
        let newsjson = await news.json();     
        if(this.discord){            
            this.news.title = newsjson.discord.title;
            this.news.content = this.markdownToHTML(newsjson.discord.content);
        }else{
            this.news.title = newsjson.news.title;
            this.news.content = newsjson.news.content;
        }                   
        this.update();        
    }

    render() {              
        return html`
            <h1>${this.news.title}</h1>
            <div class="content">
                ${unsafeHTML(this.news.content)}
            </div>            
            <comments-component path=${window.location.pathname}></comments-component>
        `;
    }
}

customElements.define('news-page', NewsPage);